import { mergeConfig} from '../rest'
import { athubAxios } from '../../util'

import { KNOWLEDGE_SERVER } from '../server'

const report = {
  server: KNOWLEDGE_SERVER,
  resource: 'report'
};
report.getAbstractReportByDepartment = function({in_departmentIds, ge_enterTime, le_enterTime}, config) {
  return athubAxios.get(addParamsToUrl([report.server, report.resource, 'abstractReportByDepartment'].join('/'), {
    in_departmentIds: in_departmentIds,
    ge_enterTime: ge_enterTime,
    le_enterTime: le_enterTime,
  }), mergeConfig(config));
};

report.getAbstractAddCountByDepartment = function({in_departmentIds, ge_enterTime, le_enterTime}, config) {
  return athubAxios.get(addParamsToUrl([report.server, report.resource, 'abstractAddCountByDepartment'].join('/'), {
    in_departmentIds: in_departmentIds,
    ge_enterTime: ge_enterTime,
    le_enterTime: le_enterTime,
  }), mergeConfig(config));
};

report.getAbstractClickCountByDepartment = function({in_departmentIds, ge_enterTime, le_enterTime}, config) {
  return athubAxios.get(addParamsToUrl([report.server, report.resource, 'abstractClickCountByDepartment'].join('/'), {
    in_departmentIds: in_departmentIds,
    ge_enterTime: ge_enterTime,
    le_enterTime: le_enterTime,
  }), mergeConfig(config));
};

report.getAbstractHotByDepartment = function({in_departmentIds, ge_enterTime, le_enterTime}, config) {
  return athubAxios.get(addParamsToUrl([report.server, report.resource, 'abstractHotByDepartment'].join('/'), {
    in_departmentIds: in_departmentIds,
    ge_enterTime: ge_enterTime,
    le_enterTime: le_enterTime,
  }), mergeConfig(config));
};
report.getAbstractAddCountByUser = function({ge_enterTime, le_enterTime, in_enterBys}, config) {
  return athubAxios.get(addParamsToUrl([report.server, report.resource, 'abstractAddCountByUser'].join('/'), {
    ge_enterTime: ge_enterTime,
    le_enterTime: le_enterTime,
    in_enterBys: in_enterBys,
  }), mergeConfig(config));
};
report.getUserClickCount = function({ge_enterTime, le_enterTime, in_enterBys}, config) {
  return athubAxios.get(addParamsToUrl([report.server, report.resource, 'userClickCount'].join('/'), {
    ge_enterTime: ge_enterTime,
    le_enterTime: le_enterTime,
    in_enterBys: in_enterBys,
  }), mergeConfig(config));
};
report.getAbstractHot = function({ge_enterTime, le_enterTime, in_enterBys}, config) {
  return athubAxios.get(addParamsToUrl([report.server, report.resource, 'abstractHot'].join('/'), {
    ge_enterTime: ge_enterTime,
    le_enterTime: le_enterTime,
    in_enterBys: in_enterBys,
  }), mergeConfig(config));
};
report.getWordByQueryCount = function({ge_enterTime, le_enterTime, in_enterBys}, config) {
  return athubAxios.get(addParamsToUrl([report.server, report.resource, 'wordByQueryCount'].join('/'), {
    ge_enterTime: ge_enterTime,
    le_enterTime: le_enterTime,
    in_enterBys: in_enterBys,
  }), mergeConfig(config));
};
report.getKeywordByQueryCount = function({ge_enterTime, le_enterTime, in_enterBys}, config) {
  return athubAxios.get(addParamsToUrl([report.server, report.resource, 'keywordByQueryCount'].join('/'), {
    ge_enterTime: ge_enterTime,
    le_enterTime: le_enterTime,
    in_enterBys: in_enterBys,
  }), mergeConfig(config));
};

function addParamsToUrl(url, params) {
  if (params === undefined || params === null) {
    return url;
  }
  let index = url.indexOf('?');
  let prefix = '';
  if (index === - 1) {
    prefix = '?';
  } else if (index === url.length - 1) {
    prefix = '';
  } else {
    prefix = '&';
  }
  let urlParams = [];
  for (let key in params) {
    if (params.hasOwnProperty(key) && params[key] !== undefined && params[key] !== null && String(params[key]).trim() !== '') {
      urlParams.push(key + '=' + encodeURIComponent(params[key]));
    }
  }
  url += prefix + urlParams.join('&');
  return url;
}
export default report;